import type { ApiAccountJSON } from '@/mastodon/api_types/accounts';
import { limitedFederationMode } from '@/mastodon/initial_state';
import type { Account } from '@/mastodon/models/account';

/**
 * Collections are not offered on a server that does not federate: the
 * menus, the profile section and the notification filters leave them out.
 */
export const collectionsHidden = limitedFederationMode;

export const getCollectionPath = (id: string) => `/collections/${id}`;

export const canAccountBeAdded = (account: ApiAccountJSON | Account) =>
  ['automatic', 'manual'].includes(account.feature_approval.current_user);

export const canAccountBeAddedByFollowers = (
  account: ApiAccountJSON | Account,
) =>
  account.feature_approval.automatic.includes('followers') ||
  account.feature_approval.manual.includes('followers');
